import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import HeaderLogoIcon from "../../../components/headerLogoIcons/headerLogoIcons";
import FooterHomePage from "../../../components/footerHomePage/footerHomePage";
import Narvbarleft from "../../../components/NarvBarLeft/NarvBarLeft";
import DownloadButton from "../DownloadButton/DownloadButton";
import PrintButton from "../PrintButton/PrintButton";
import "./ABMDetail.css";
import { AiFillCheckCircle } from "react-icons/ai";
import { TiDelete } from "react-icons/ti";

const ABMDetailL = () => {
  const location = useLocation();
  let data = location.state;
  const [aMB, setAMB] = useState([]);
  const [decodedTypeDocument, setDecodedTypeDocument] = useState("");

  //Utilizar el sesion storage está limitado a la pestaña o ventana actual, y los datos se borran cuando se cierra la pestaña o ventana.
  if (!data) {
    const storedData = sessionStorage.getItem("reportData");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles.
    sessionStorage.setItem("reportData", JSON.stringify(data));
  }

  const searchDocumentABM = async (e) => {
    e.preventDefault();
    const userId = data.id;
    const apiUrl = `${process.env.REACT_APP_LEALTAD_ABM_OF_DOCUMENT_GET_ALL_TYPE}?userId=${userId}&typeDocument=${decodedTypeDocument}`;

    try {
      const response = await axios.get(apiUrl);
      if (response.status === 204) {
        setAMB([]);
      } else {
        setAMB(response.data);
      }
    } catch (error) {
      setAMB([]);
    }
  };

  return (
    <div className="abmlistone-lealtad">
      <HeaderLogoIcon />
      <div className="boxDisABMList-lealtad">
        <Narvbarleft />
        <div className="abmlisttablebox-lealtad">
          <div className="boxabmsearcharchive-lealtad">
            <div>
              <select
                className="inputsabmsearchlist-lealtad"
                onChange={(e) => setDecodedTypeDocument(e.target.value)}
              >
                {data.RelationshipWithMutual.relation === "Socio" ? (
                  <>
                    <option value="">Seleccione un tipo de archivo</option>
                    <option value="Legajo">Legajo</option>
                    <option value="Recibo de sueldo">Recibo de sueldo</option>
                    <option value="Certificado de afectación">
                      Certificado de afectación
                    </option>
                    <option value="Servicio a su nombre">
                      Servicio a su nombre
                    </option>
                    <option value="Constancia a su nombre">
                      Constancia a su nombre
                    </option>
                    <option value="Documentación complementaria">
                      Documentación complementaria
                    </option>
                  </>
                ) : data.RelationshipWithMutual.relation === "Proveedor" ? (
                  <>
                    <option value="">Seleccione un tipo de archivo</option>
                    <option value="Constancia de monotributo">
                      Constancia de monotributo
                    </option>
                    <option value="DNI">DNI</option>
                    <option value="DJ PEP AUTORIDADES (134/2018)">
                      DJ PEP AUTORIDADES (134/2018)
                    </option>
                    <option value="ESTATUTO - REFORMA ESTATUTARIA">
                      ESTATUTO - REFORMA ESTATUTARIA
                    </option>
                    <option value="ULTIMO BALANCE CERTIFICADO">
                      ULTIMO BALANCE CERTIFICADO
                    </option>
                    <option value="DJ DE PERSONAS JURIDICAS">
                      DJ DE PERSONAS JURIDICAS
                    </option>
                    <option value="Otra documentación">
                      Otra documentación
                    </option>
                  </>
                ) : (
                  <>
                    <option value="">Seleccione un tipo de archivo</option>
                    <option value="ESTATUTO - REFORMA ESTATUTARIA">
                      ESTATUTO - REFORMA ESTATUTARIA
                    </option>
                    <option value="ULTIMO BALANCE CERTIFICADO">
                      ULTIMO BALANCE CERTIFICADO
                    </option>
                    <option value="DJ DE PERSONAS JURIDICAS">
                      DJ DE PERSONAS JURIDICAS
                    </option>
                    <option value="DJ ORIGEN Y LICITUD DE FONDOS PERSONA JURÍDICA">
                      DJ ORIGEN Y LICITUD DE FONDOS PERSONA JURÍDICA
                    </option>
                    <option value="DJ DE AUTORIDADES VIGENTES">
                      DJ DE AUTORIDADES VIGENTES
                    </option>
                    <option value="ACTA DE ASAMBLEA DE DESIGNACION DE AUTORIDADES VIGENTES">
                      ACTA DE ASAMBLEA DE DESIGNACION DE AUTORIDADES VIGENTES
                    </option>
                    <option value="ACTA DE ORGANO DIRECTIVO DE DISTRIBUCION DE CARGOS">
                      ACTA DE ORGANO DIRECTIVO DE DISTRIBUCION DE CARGOS
                    </option>
                    <option value="DNI DE AUTORIDADES VIGENTES">
                      DNI DE AUTORIDADES VIGENTES
                    </option>
                    <option value="CONSTANCIA INSCRIPCION UIF (DE CORRESPONDER)">
                      CONSTANCIA INSCRIPCION UIF (DE CORRESPONDER)
                    </option>
                    <option value="DJ PEP AUTORIDADES (134/2018)">
                      DJ PEP AUTORIDADES (134/2018)
                    </option>
                    <option value="DJ CUMPLIMIENTO NORMATIVAS UIF - OFICIAL DE CUMPLIMIENTO (DE CORRESPONDER)">
                      DJ CUMPLIMIENTO NORMATIVAS UIF - OFICIAL DE CUMPLIMIENTO
                      (DE CORRESPONDER)
                    </option>
                    <option value="CONSTANCIA INSCRIPCION UIF OFICIAL DE CUMPLIMIENTO">
                      CONSTANCIA INSCRIPCION UIF OFICIAL DE CUMPLIMIENTO
                    </option>
                    <option value="ACTA DE ASAMBLEA DESIGNACION OFICIAL DE CUMPLIMIENTO">
                      ACTA DE ASAMBLEA DESIGNACION OFICIAL DE CUMPLIMIENTO
                    </option>
                    <option value="ACTA DE ORGANO DIRECTIVO APROBACION MANUAL DE PROCEDIMIENTOS PLA/FT">
                      ACTA DE ORGANO DIRECTIVO APROBACION MANUAL DE
                      PROCEDIMIENTOS PLA/FT
                    </option>
                    <option value="COPIA DEL MANUAL DE PROCEDIMIENTOS PLA/FT">
                      COPIA DEL MANUAL DE PROCEDIMIENTOS PLA/FT
                    </option>
                  </>
                )}
              </select>
            </div>
            <div>
              <button
                className="buttonsearchabmlist-lealtad"
                onClick={(e) => searchDocumentABM(e)}
              >
                Buscar Archivo
              </button>
            </div>
          </div>
          <table className="abmlisttable-lealtad">
            <thead>
              <tr>
                <th className="headertabbleabmlist-lealtad">Estado</th>
                <th className="headertabbleabmlist-lealtad">Tipo de archivo</th>
                <th className="headertabbleabmlist-lealtad">Descripcion</th>
                <th className="headertabbleabmlist-lealtad">
                  Fecha de creación
                </th>
                <th className="headertabbleabmlist-lealtad">Descargar</th>
                <th className="headertabbleabmlist-lealtad">Imprimir</th>
              </tr>
            </thead>
            <tbody>
              {aMB.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="tableabm-lealtad">
                      {item.status === "Alta" ? (
                        <AiFillCheckCircle style={{ color: "green" }} />
                      ) : (
                        <TiDelete style={{ color: "red" }} />
                      )}
                    </td>
                    <td className="tableabm-lealtad">{item.typeDocument}</td>
                    <td className="tableabm-lealtad">{item.description}</td>
                    <td className="tableabm-lealtad">{item.createAt}</td>
                    <td className="tableabm-lealtad">
                      <DownloadButton
                        id={item.id}
                        typeDocument={item.typeDocument}
                      />
                    </td>
                    <td className="tableabm-lealtad">
                      <PrintButton id={item.id} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterHomePage />
    </div>
  );
};

export default ABMDetailL;
